module.exports = __webpack_public_path__ + "static/img/earlyMorningShift.d2765676.svg";